import React from "react";
import "@/App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import Landing from "@/pages/Landing";
import CustomerLogin from "@/pages/CustomerLogin";
import StaffLogin from "@/pages/StaffLogin";
import CustomerDashboard from "@/pages/CustomerDashboard";
import StaffDashboard from "@/pages/StaffDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import GoogleAuthCallback from "@/pages/GoogleAuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import WhatsAppButton from "@/components/WhatsAppButton";
import BookTrip from "@/pages/BookTrip";

function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login/customer" element={<CustomerLogin />} />
        <Route path="/join" element={<CustomerLogin />} />
        <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login/staff" element={<StaffLogin mode="staff" />} />
        <Route path="/login/admin" element={<StaffLogin mode="admin" />} />
        <Route
          path="/customer"
          element={
            <ProtectedRoute roles={["customer"]}>
              <CustomerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/book"
          element={
            <ProtectedRoute roles={["customer"]}>
              <BookTrip />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff"
          element={
            <ProtectedRoute roles={["staff", "admin"]}>
              <StaffDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <WhatsAppButton />
    </div>
  );
}

export default App;
